import axiosHttp from "./interceptor.service";

const postLeave = (id, data) => {
  return axiosHttp.post(`/lmt/leave/${id}`, data);
};
const getLeave = ({ date, search, type, employeeId, startDate, endDate } = {}) => {
  return axiosHttp.get("/lmt/getLeave", {
    params: { date, search, type, employeeId, startDate, endDate },
  });
};

const getLeaveByUserId = (userId, { date, search, type, startDate, endDate } = {}) => {
  return axiosHttp.get(`/lmt/getLeave/${userId}`, {
    params: { date, search, type, startDate, endDate },
  });
};

const getUserLeaveDetail = (id, data) => {
  return axiosHttp.get(`/lmt/getLeaveDetails/${id}`, data);
};

const updateLeave = (id, data, { leaveDayId } = {}) => {
  return axiosHttp.put(`/lmt/updateLeave/${id}`, data, {
    params: {
      leaveDayId,
    },
  });
};

const deleteLeave = (id, { leaveDayId, userId } = {}) => {
  return axiosHttp.delete(`/lmt/deleteLeave/${id}`, {
    params: {
      leaveDayId,
      userId,
    },
  });
};

const getLeaveType = (data) => {
  return axiosHttp.get("/lmt/getLeaveType", data);
};

const getLeaveCountsSummary = ({ startDate, endDate, year, month } = {}) => {
  return axiosHttp.get("/lmt/getLeaveCountsSummary", {
    params: { startDate, endDate, year, month },
  });
};

const getLeaveBalanceSummary = ({ month, year } = {}) => {
  return axiosHttp.get("/lmt/getLeaveBalanceSummary", {
    params: { month, year },
  });
};

export {
  postLeave,
  getLeave,
  getLeaveByUserId,
  getUserLeaveDetail,
  updateLeave,
  deleteLeave,
  getLeaveType,
  getLeaveCountsSummary,
  getLeaveBalanceSummary,
  getLeaveHistoryForSummary,
};

const getLeaveHistoryForSummary = (userId, { startDate, endDate, status } = {}) => {
  console.log("Frontend Service: Calling getLeaveHistoryForSummary", userId, startDate, endDate, status);
  return axiosHttp.get(`/lmt/getLeaveHistoryForSummary/${userId}`, {
    params: { startDate, endDate, status },
  });
};

